import { render, staticRenderFns } from "./GetStartedView.vue?vue&type=template&id=f6082ab8&"
import script from "./GetStartedView.vue?vue&type=script&lang=js&"
export * from "./GetStartedView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports